import { localStorageAdapter } from '@/services/app.service';
import * as _ from 'lodash';
// @ts-ignore
import allService from '../services/all.service';
// TODO fetch categories from API
var categoryService = {
    setCategoriesForStorage: function (categories) {
        localStorageAdapter.setItem('categories', categories);
    },
    getCategoriesFromStorage: function () {
        var categories = localStorageAdapter.getItem('categories');
        return categories;
    },
    // TODO should be it's own call
    fetchAll: function (callback) {
        return allService.load(function (_a) {
            var menu = _a.menu;
            callback(menu);
        });
    },
    // get the first item within a category
    firstItemInCategory: function (category) {
        return category.firstItemInCategory();
    },
    sectionsInCategory: function (category) {
        return category.sectionsInCategory();
    },
    // TODO category ID should always be string
    getCategoryForItem: function (categories, itemId) {
        var category = _.find(categories, function (category) {
            var id = category.itemIdInCategory(itemId);
            if (id) {
                return true;
            }
            return false;
        });
        if (category) {
            return category.id;
        }
        console.error("Item " + itemId + " not found in any category");
        return '';
    }
};
export default categoryService;



//////////////////
// WEBPACK FOOTER
// ./src/services/category.service.ts
// module id = RBdY
// module chunks = 18